// Libraries
import React from 'react';
import styled, { keyframes } from 'styled-components';

// Components
import ErrorContainer from '../login/error-page/error-container';

// Assets
import ErrorImageBackground from '~/assets/images/login/img-error-background.jpg';

/**
 *
 *
 * @class NotFoundPage
 * @extends {Component}
 */
const NotFoundPage = props => (
	<div id="page-header" className="utilities--above-the-fold">
		<Wrapper id="not-found-page" className="grid-x">
			<ErrorContainer greeting="404 - Page not found" message="Page Not Found" />
			<BackgroundImage
				id="error-background-image"
				className="cell large-7 medium-6 small-12"
				style={{
					backgroundImage: `url(${ErrorImageBackground})`,
				}}
			/>
		</Wrapper>
	</div>
);

// Styled Components
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	padding: 0;
	min-height: 100vh;
	flex: 1;
	background-color: #006aee;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
`;

const BackgroundImage = styled.figure`
	width: 100%;
	height: 100%;
	min-height: 100vh;
	display: none;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: left center;
	animation-name: ${fadeIn};
	animation-duration: 2000ms;
	animation-timing-function: ${props => props.easeInCirc};

	@media ${props => props.theme.breakpointLarge} {
		display: block;
		display: flex;
	}
`;

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/not-found/index.jsx